import React from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import { StyledText } from '../../../components/StyledText';
import { formatDollarsAsMillions } from '../../../lib/utils';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    background: '#F4F6F8',
    borderRadius: 8,
    padding: '10px 15px',
    marginTop: '10px'
  }
}));
interface ConnectorDealFinancePanelProps {
  currentRevenue: number
  financeRaised: number
  financeSoughtLow: number
  financeSoughtHigh: number
  fiveYearsFinProjection?: number
}

const ConnectorDealFinancePanel: React.FC<ConnectorDealFinancePanelProps> = ({
  currentRevenue,
  financeRaised,
  financeSoughtLow,
  financeSoughtHigh,
  fiveYearsFinProjection
}) => {
  const styles = useStyles();
  return (
    <Grid container justify='space-between' className={styles.root} spacing={1}>
      <Grid item>
        <StyledText variant='body1' color='textSecondary' component='div'>
          Funding sought
        </StyledText>
        <StyledText variant='financials' color='primary'>
          {`${formatDollarsAsMillions(financeSoughtLow)} - ${formatDollarsAsMillions(financeSoughtHigh)}`}
        </StyledText>
      </Grid>
      <Grid item>
        <StyledText variant='body1' color='textSecondary' component='div'>
          Raised Already
        </StyledText>
        <StyledText variant='financials' color='primary'>
          {formatDollarsAsMillions(financeRaised)}
        </StyledText>
      </Grid>
      <Grid item>
        <StyledText variant='body1' color='textSecondary' component='div'>
          Current Revenue
        </StyledText>
        <StyledText variant='financials' color='primary'>
          {formatDollarsAsMillions(currentRevenue)}
        </StyledText>
      </Grid>
      <Grid item>
        <StyledText variant='body1' color='textSecondary' component='div'>
          Year 5 Projected Revenue
        </StyledText>
        <StyledText variant='financials' color={fiveYearsFinProjection ? 'primary' : 'textSecondary'}>
          {fiveYearsFinProjection ? formatDollarsAsMillions(fiveYearsFinProjection) : '$_'}
        </StyledText>
      </Grid>
    </Grid>
  );
};

export default ConnectorDealFinancePanel;
